import LineBase from '@/renderers/d3-wave/models/LineBase';

export default class InfiniteLine extends LineBase {
}
